<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('ftp_settings')"
          :text="$t('ftp_settings_info_text')"
          :btnText="$t('add_ftp_setting')"
          @action="goToAdd" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            @click="goToEdit(item.id)"
            v-for="(item, index) in get_ftp_settings.items" :key="`item-${index}`">
            <div class="table-cell small">
              <Icon
                :circle=true
                :name="item.template_type === 'ftp_shipment_output_fields' ? 'cloudDownload' : 'cloudUpload'"
                size="20" />
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name}` }}
              </span>
                <span class="additional-info">{{ $t(item.template_type) }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import InfoTextBox from '@/components/global/infoTextBox';

/* eslint-disable */
export default {
  name: 'ftp',
  components: { InfoTextBox },
  data() {
    return {
      ftpSettingId: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_ftp_settings',
      'get_ftp_setting_by_id',
    ]),
  },
  created() {
    this.$store.dispatch('GET_FTP_SETTINGS');
  },
  methods: {
    goToAdd() {
      this.$router.push({ path: '/settings/integration/add-ftp-template' });
    },
    goToEdit(id) {
      this.$router.push({ path: `/settings/integration/edit-ftp-template/${id}` });
    }
  },
};
</script>
